export default "__VITE_ASSET__dvM9UgX$__"